export default __webpack_public_path__ + "static/noissue-101-right-e33cf34e9488fc3c349bcb8161044e0f.svg";